import { RouteObject } from 'react-router-dom'
import { lazy } from 'react'

const Home = lazy(() => import('../pages/home/page'))
const NotFound = lazy(() => import('../pages/NotFound'))
const Servicios = lazy(() => import('../pages/servicios/page'))
const CuidadoPorHoras = lazy(() => import('../pages/cuidado-por-horas/page'))
const CuidadosInternos = lazy(() => import('../pages/cuidados-internos/page'))
const CuidadosSAD = lazy(() => import('../pages/cuidados-sad/page'))
const TrabajaConNosotros = lazy(() => import('../pages/trabaja-con-nosotros/page'))

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />
  },
  {
    path: '/servicios',
    element: <Servicios />
  },
  {
    path: '/cuidado-por-horas',
    element: <CuidadoPorHoras />
  },
  {
    path: '/cuidados-internos',
    element: <CuidadosInternos />
  },
  {
    path: '/cuidados-sad',
    element: <CuidadosSAD />
  },
  {
    path: '/trabaja-con-nosotros',
    element: <TrabajaConNosotros />
  },
  {
    path: '*',
    element: <NotFound />
  }
]

export default routes
